import React from 'react';
import styled from 'styled-components';
import phone from '../assets/images/phone-call.svg';

const PhoneStyles = styled.div`
  position: fixed;
  top: 70%;
  right: 50px;

  .wrapper {
    width: 75px;
    height: 75px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background-color: #25d366;
    box-shadow: 0 0 8px 8px #f0f, 0 0 28px #f0f inset;
    -webkit-animation: phone-animate 0.6s linear infinite alternate;
    animation: phone-animate 0.6s linear infinite alternate;
  }
  img {
    width: 50px;
    height: 50px;
  }

  @-webkit-keyframes phone-animate {
    0% {
      -webkit-transform: rotate(0);
      transform: rotate(0);
      box-shadow: 0 0 8px 8px #25d366, 0 0 28px #25d366 inset;
    }
    100% {
      -webkit-transform: rotate(30deg);
      transform: rotate(30deg);
      box-shadow: 0 0 8px 28px #075e54, 0 0 78px #075e54 inset;
    }
  }
  @keyframes phone-animate {
    0% {
      -webkit-transform: rotate(0);
      transform: rotate(0);
      box-shadow: 0 0 8px 8px #25d366, 0 0 28px #25d366 inset;
    }
    100% {
      -webkit-transform: rotate(30deg);
      transform: rotate(30deg);
      box-shadow: 0 0 8px 28px #075e54, 0 0 78px #075e54 inset;
    }
  }
`;
function Phone() {
  return (
    <PhoneStyles>
      <a href="tel:01025440616">
      <div className='wrapper'>
        <img src={phone} alt='phone' />
      </div>
      </a>
    </PhoneStyles>
  );
}

export default Phone;
